import React, { useState,useEffect } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';


export default function InitialPopup({PopupVisible, setPopupVisible}) {



    
const [userName, setUserName] = useState('');
const navigate = useNavigate();


useEffect(()=>{
  let data = JSON.parse(localStorage.getItem("userDetails"))
  

  if(data && (data["name"] === null))
    {
      // document.getElementById('Details').classList.remove('none');
      // setBlur("ON");

       setPopupVisible(true)
    }
},[])

  function cheakUserName(){
    const regex = /[^a-zA-Z]/g;
   
    return !regex.test(userName);
  }
  const addNameToDatabase = async()=>{

    if(cheakUserName())
      {

          setPopupVisible(false);
          let data = JSON.parse(localStorage.getItem("userDetails"))

          
          data["name"] = userName;
          localStorage.setItem("userDetails", JSON.stringify(data));
          let data2 = localStorage.getItem("userDetails")
          

          try {

            let uri = process.env.REACT_APP_Realtime_Firebase;
            let response = await fetch(uri + 'Visits.json', {
              method: 'POST',
              headers: {
                "Content-Type": "application/json"
              },
        
              body: JSON.stringify(userName)
            })
            
            
          }
          catch(e){
            
          }
      
          
          navigate('/')
      }
      else{
        alert('Please add name correctly!')
      }


    
  }
  
  return (
    <div className={`h-full  ${PopupVisible ? 'block': ''} z-50 flex justify-center items-center bg-black  absolute w-screen`}>
      
      <div className='text-gray-900 opacity-90 w-96 rounded-md h-52 bg-gray-500'>

        <div for="website-admin" class="block w-fit font-bold hover:text-red-500 cursor-pointer mb-2 text-sm mx-auto  mt-2  text-white">Enter your name to Continue</div>
        <div class="flex m-3 rounded-md ">
          <span class="inline-flex items-center px-3 text-sm  border rounded-e-0  border-e-0 rounded-s-md bg-gray-600 text-gray-400 border-gray-600">
            <svg class="w-4 h-4 text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z"/>
            </svg>
          </span>
          <input onChange={(e)=>setUserName(e.target.value)} value={userName} type="text" id="website-admin" class="rounded-none rounded-e-lg  border  block flex-1 min-w-0 w-full text-sm  p-2.5  bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" placeholder="Enter your Name"/>
        </div>

        <div className='flex justify-between mx-12 mt-16'>
                <button type="button" onClick={()=>addNameToDatabase()}  class="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 shadow-lg shadow-green-500/50 dark:shadow-lg dark:shadow-green-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Done</button>
          <Link to={'/userDetails'} class="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 shadow-lg shadow-red-500/50 dark:shadow-lg dark:shadow-red-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Enter more Details -&gt;</Link>
      
        </div>
      </div>
    </div>
  )
}


